import { IDictionary, ReadonlyRecord } from '@bimser/core';
import { Map, Record } from 'immutable';

interface IBaseBrowserProperties {
	blockingType: number;
	browserList: string[];
	customBrowserQuery: string;
	isBlocked: boolean;
}

export interface IBrowserProperties extends IBaseBrowserProperties {
	customMessageHeader: IDictionary<string>;
	customMessageBody: IDictionary<string>;
}

export interface IReadonlyBrowserProperties extends IBaseBrowserProperties {
	customMessageHeader: Map<string, string>;
	customMessageBody: Map<string, string>;
}

export type BrowserProperties = ReadonlyRecord<IReadonlyBrowserProperties>;

export const BrowserPropertiesFactory = Record<IReadonlyBrowserProperties>({
	blockingType: null,
	browserList: [],
	customBrowserQuery: '',
	isBlocked: null,
	customMessageHeader: Map(),
	customMessageBody: Map()
});

export const BrowserPropertiesFactoryFromJS = function (data: IBrowserProperties) {
	return BrowserPropertiesFactory({
		...data,
		customMessageHeader: Map(data.customMessageHeader),
		customMessageBody: Map(data.customMessageBody)
	});
};
